/* eslint-disable react/no-danger */
import * as React from 'react';

// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import CML from 'bundles/cml/legacy/components/CMLViewer';
import type { CmlContent } from 'bundles/cml/legacy/types/Content';
import type { Content } from 'bundles/compound-assessments/components/api/types/CompoundAssessmentsForm';
import type { CMLOrHTMLContent } from 'bundles/compound-assessments/types/FormParts';

type Props = {
  value: string | CmlContent | Content | CMLOrHTMLContent | undefined;
  assumeStringIsHtml?: boolean;
  isControlled?: boolean;
  className?: string;
  id?: string;
  display?: 'inline-block' | undefined;
  shouldRenderFillableBlanks?: boolean;
};

/**
 * Use this component to render CML/HTML/Text
 */
/** @deprecated we only use HTML storage for legacy workflows, please use one of the other CML viewers to support new development */
const CMLOrHTML = ({
  value,
  assumeStringIsHtml = true,
  shouldRenderFillableBlanks,
  isControlled,
  className,
  id,
  display,
}: Props): React.ReactElement<'div' | 'span'> | null => {
  const rest = {
    isControlled,
    className,
    contentId: id,
    display,
    shouldRenderFillableBlanks,
  };

  if (!value) {
    return null;
  }

  if (typeof value === 'object') {
    if (value.typeName === 'cml' || value.typeName === 'cmlContent') {
      return <CML cml={value as CmlContent} {...rest} isCdsEnabled />;
    } else if (value.typeName === 'htmlText') {
      return <span className={className} id={id} dangerouslySetInnerHTML={{ __html: value.definition.content }} />;
    } else if (value.typeName === 'htmlContent') {
      return <span className={className} id={id} dangerouslySetInnerHTML={{ __html: value.definition.html }} />;
    }
  } else if (assumeStringIsHtml) {
    return <span className={className} id={id} dangerouslySetInnerHTML={{ __html: value }} />;
  } else {
    return (
      <span className={className} id={id}>
        {value}
      </span>
    );
  }

  return null;
};

export default CMLOrHTML;
